//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import stepTitle from "./components/StepTitle"
import datePicker from "./components/DatePicker"
import step from '@/components/Step'
import top from '@/components/top'
import serviceBtn from '@/components/service-btn'
import { dataMixins } from '@/mixins'
import next from '@/components/utake-next-fixed'
import { contractPeriod, way, broadbandWay, baseInfo, broadbandInfo, discountVas } from './components'
import { getCache } from '@/utils/storage'
import config from '@/service/config'
import Vue from 'vue';

const formattingTime = param => {
  let _time = param.split('-').map(e => {
    if (e * 1 < 10) return `0${e}`
    else return e
  })
  return _time.join('-')
}
export default {
  mixins: [dataMixins],
  computed: {
    businessScenesTypeComputed () {
      if (this.businessScenesType == 1) {
        //1 可以选择 專人辦理和自助办理的服务计划
        return true
      }
      //只有自助办理的服务计划
      return false
    },
    disBusinessScenesType () {
      // 可选择 自助办理和专人办理的业务
      if (this.businessScenesType == 1) {
        return true
      }
      // 不可选择 自助办理和专人办理的业务, 默认type == 1 自助办理
      return false
    },
    showDis () { // 是否展示上台优惠
      let show = false;
      //currentDiscDataLv1List有数据，并且为非必选 显示优惠内容
      let dataLv1List = this.currentDiscDataLv1List
      //需求，所有都是必选的时候，隐藏
      let mustSelect = true
      dataLv1List.forEach(element => { //required == 1 为必选  == 2 可选
        if (element.required * 1 == 2 || element.required * 1 == 3) {
          mustSelect = false
        }
      })
      let showDiscData = this.currentDiscDataLv1List.length && !mustSelect
      //currentPackageLv1Listy有数据，并且为非必选 显示优惠内容
      let packageLv1List = this.currentPackageLv1List
      let allMustSelect = true
      packageLv1List.forEach(element => {
        let discountsList = element.discountsList || []
        discountsList.forEach(zelement => {
          if (zelement.required * 1 == 2 || zelement.required * 1 == 3) {
            allMustSelect = false
          }
        })
      })
      let showPackageData = this.currentPackageLv1List.length && !allMustSelect
      if (this.type != 2 &&
        (showDiscData || showPackageData)) {
        show = true
      }
      return show
    },
    showVas () { // 是否展示上台VAS
      let show = false
      if (this.type != 2 &&
        this.currentVasDataLv1.dataLv2List &&
        this.currentVasDataLv1.dataLv2List.length &&
        !this.currentVasDataLv1.required) {
        //自助办理，并且vas列表有数据才显示vas信息, 非必选显示
        show = true
      }
      return show
    },
    showBroadbandDis () { // 是否展示宽频优惠
      let show = false
      //broadbandDiscDataLv1List有数据，并且为非必选 显示优惠内容
      let dataLv1List = this.broadbandDiscDataLv1List
      //需求，所有都是必选的时候，隐藏
      let mustSelect = true
      dataLv1List.forEach(element => { //required == 1 为必选  == 2 可选
        if (element.required * 1 == 2 || element.required * 1 == 3) {
          mustSelect = false
        }
      })
      let showDiscData = this.broadbandDiscDataLv1List.length && !mustSelect
      //broadbandPackageLv1List有数据，并且为非必选 显示优惠内容
      let packageLv1List = this.broadbandPackageLv1List
      let allMustSelect = true
      packageLv1List.forEach(element => {
        let discountsList = element.discountsList || []
        discountsList.forEach(zelement => {
          if (zelement.required * 1 == 2 || zelement.required * 1 == 3) {
            allMustSelect = false
          }
        })
      })
      let showPackageData = this.broadbandPackageLv1List.length && !allMustSelect
      if (this.type != 2 &&
        (showDiscData || showPackageData)) {
        show = true
      }
      return show
    },
    showBroadbandVas () { // 是否展示宽频VAS
      let show = false
      if (this.type != 2 &&
        this.broadbandVasDataLv1.dataLv2List &&
        this.broadbandVasDataLv1.dataLv2List.length &&
        !this.broadbandVasDataLv1.required) {
        //自助办理，并且vas列表有数据才显示vas信息, 非必选显示
        show = true
      }
      return show
    },
    daijiDiscVasCount () { // 上台优惠、vas标题展示数量
      return (this.showDis ? 1 : 0) + (this.showVas ? 1 : 0)
    },
    disVasTotal () { // 所有优惠、vas标题展示数量
      return this.daijiDiscVasCount + (this.showBroadbandDis ? 1 : 0) + (this.showBroadbandVas ? 1 : 0)
    }
  },
  data () {
    /**
     * @method validatorRegisterType 協號情況下的表單參數繳驗
     */
    let validatorRegisterType = (rule, value, callback, target, errorText) => {
      if (this.type == 2) return callback()
      if (this.registerType == 2) {
        if (!value) callback(new Error(errorText))
        else callback()
      } else callback()
    }

    // 当类型为专人办理不需要输入这些参数
    let validatorType = (rule, value, callback, text) => {
      if (this.type == 2) return callback()
      if (value === '' || value === null) callback(new Error(text))
      else callback()
    }

    let validatorMgmCode = (rule, value, callback) => {
      if (this.type == 2) return callback()
      let result = this.$regex('phone', value)
      if (!value) {
        callback()
      } else if (value.length < 8 || !result) {
        callback(new Error('請輸入正確的推薦人號碼'))
      } else {
        callback()
      }
    }

    return {
      homePhoneName: '家居電話（基本月費$28）',  // 家居電話信息
      openHomePhone: false, // 是否開通家居電話
      broadbandOrderAllInfo: {},  // umall 1+N存儲地址寬頻服務計劃數據
      registerOrderAllInfo: {},  // umall 1+N存儲上台服務計劃數據
      isShowMgnInput: false, //是否顯示推薦人輸入框
      newId: '',//订单查询再次上台时，因取消订单或完成订单新生成的订单ID
      currentVasDataLv1: {},  // 上台优惠 vas
      currentDiscDataLv1List: [],
      currentPackageLv1List: [],
      broadbandVasDataLv1: {},  // 宽频优惠vas
      broadbandDiscDataLv1List: [],
      broadbandPackageLv1List: [],
      registerTypeId: 1, //获取优惠信息的隔离字段  default=1 新号码上台
      businessScenesType: null,
      info: {},
      broadbandInfo: {},
      type: '1', // 选中的类型 1：网上送货(自助办理) 2：专人办理
      id: '', // 业务订单id
      dialog: {
        show: false,
        showDis: false,
        title: '',
        content: ''
      },
      //          details: 'businessInfo', // 用於顯示底部數據的索引 businessInfo/businessDesc
      details: '', // 用於顯示底部數據的索引 businessInfo/businessDesc
      gerencode: '', //Mgm 个人code
      mgmMethod: '2', //1.线上赠送，2.线下赠送
      packageType: '', //業務包類型
      dataInfoId: '', //選中的業務包id
      disRecords: [],
      form: {
        broadbandOrderAllInfo: {
          homePhone: '',  // 家居电话
          homePhoneType: '3', // 家居电话类型 1:新号上台，2:携号上台,3:未选家居电话
          homePhoneEffectDate: null,
          addressOfferIds: '',  // 地址优惠id
          phoneNumber: ''
        },  // 宽频订单信息
        registerType: '1', // 办理方式 默認為手機辦理
        phoneNo: '', // 电话号码
        effectDate: '',	// 生效日期
        effectTime: '',	// 生效时间
        effectiveEndDate: '', // 生效截止日期
        billType: '1', // 賬單方式
        billLang: '1',  //賬單語言 1：中文 2：英文
        customerInfo_referrerMsisdn: '', //推薦人id 最多8位數字
        certificateAttach: '', // 身份证證件副本
        contactAddressInfoVo: '', // 联络地址
        transactType: '2', // 卡类型 2.实体卡（网上送货)，5.esim，6.顺丰自取柜
        customerInfo: {}, // 客户信息
        isNonSelf: '', // 是否是学生本人
        // subCustInfo: '', // 子客戶信息
        businessType: '', // 业务类型
        stuCardAttach: '', // 学生证证件副本
        takeRegion: '', //辨理方式自取柜时必填 取貨區域&地區
        takeOrg: '', //取貨門市或自取柜信息
        serviceOrgCode: '', //门市取卡时所选门市编号/自取柜编号 cmhk自取柜与顺丰自取柜必填
      },
      data: {
        way: {
          registerType: [
            { name: '新號碼上台', value: '1', placeholder: '請按此選擇新電話號碼' },
            { name: '攜號上台', value: '2', placeholder: '請輸入正確攜號電話號碼' }
          ],
          transactType: [
            { name: '實體SIM卡', value: '2' },
            { name: 'eSIM卡', value: '5' }
          ]
        },
        braodbandWay: {
          registerType: [
            { name: '新號碼上台', value: '1', placeholder: '請按此選擇新電話號碼' },
            { name: '攜號上台', value: '2', placeholder: '請輸入正確攜號電話號碼', describe: '溫馨提示：閣下將被安排一個臨時號碼，請完成此登記後，再親臨門市辦理轉台手續。' }
          ],
        },
        effectTime: [{
          name: '12:00',
          value: '12:00'
        },
        {
          name: '01:00',
          value: '01:00'
        },
        ],
      },
      rules: {
        effectTime: [{
          required: true,
          validator: (rule, value, callback) => validatorRegisterType(rule, value, callback, 'effectTime', '請選擇生效時間'),
          trigger: 'blur'
        }],
        effectDate: [{
          required: true,
          validator: (rule, value, callback) => validatorType(rule, value, callback, '請選擇生效日期'),
          trigger: 'blur'
        }],
        customerInfo_referrerMsisdn: [{
          required: false,
          validator: validatorMgmCode,
          trigger: 'blur'
        }],
      },
      pickerOptions: {
        disabledDate: time => {
          // 获取t+2,t+3规则(举例：今天是10月14日，T+2應是16號，所以客戶應可選16號及以後的日子，若碰上节假日或者周末就顺推)
          let rules = ({
            time,
            type
          }) => {
            let allowed = false,
              _notAllowed = [],
              _notAllowedMonthDay = ['2020-1-1', '2020-1-25', '2020-1-26', '2020-1-27', '2020-1-28', '2020-1-29', '2020-4-4', '2020-4-10', '2020-4-11', '2020-4-13', '2020-4-30', '2020-5-1', '2020-6-25', '2020-7-1', '2020-10-1', '2020-10-2', '2020-10-26', '2020-12-25', '2020-12-26']
            /**
             * @method loop 循环获取非指定日期和周末的指定日期             
             */
            const loop = ({
              date,
              maxList,
              list,
              notAllowed,
              loopHoliday = []
            }) => {
              let _date = date || new Date(),
                _today = `${_date.getFullYear()}-${_date.getMonth() + 1}-${_date.getDate()}`,
                _tomorrow = new Date(_date.getTime() + 24 * 60 * 60 * 1000)
              if (list.length === maxList * 1) {
                // 获取t+n中的n(n为为周末和节假日)
                let holiday = (date, notAllowed, list = []) => {
                  let today = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`
                  // 只要不是节假日和周末就停下,返回之前添加的不允许列表
                  if (date.getDay() != 6 && date.getDay() != 0 && notAllowed.indexOf(today) == -1) return list
                  else {
                    list.push(today)
                    return holiday(new Date(date.getTime() + 24 * 60 * 60 * 1000), notAllowed, list)
                  }
                }
                return Array.from(new Set([...list, ...holiday(_date, notAllowed), ...loopHoliday]))
                // return list
              }
              if (_date.getDay() != 6 && _date.getDay() != 0 && notAllowed.indexOf(_today) == -1) {
                list.push(_today)
                notAllowed.push(_today)
              } else loopHoliday.push(_today)
              return loop({
                date: _tomorrow,
                maxList: maxList,
                list: list,
                notAllowed: notAllowed,
                loopHoliday: loopHoliday
              })
            }
            let _maxList = type === 't+2' ? 2 : 3
            if (this.transactType == 6) _maxList += 1
            _notAllowed = loop({
              maxList: _maxList,
              list: [],
              notAllowed: _notAllowedMonthDay
            })
            _notAllowed.some(e => {
              let _time = `${time.getFullYear()}-${time.getMonth() + 1}-${time.getDate()}`
              if (new Date(formattingTime(_time)).getTime() == new Date(formattingTime(e)).getTime()) {
                if (this.form.effectDate && new Date(this.form.effectDate).getTime() === time.getTime()) this.form.effectDate = null
                return allowed = true
              }
            })
            return allowed
          }
          // 新增逻辑强制指定日期不允许选择
          let ban = (t) => {
            let _banList = ['2020-1-25', '2020-1-26', '2020-1-27', '2020-1-28', '2020-1-29', '2020-1-30'] // 直接禁止选择的日期列表       
            let isBan = false
            let date = new Date(t)
            let temp = new Date(formattingTime(`${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`)).getTime()
            // let temp = new Date(formattingTime(time)).getTime()            
            _banList.some(e => {
              if (new Date(formattingTime(e)).getTime() == temp) return isBan = true
            })
            return isBan
          }
          // 限制只能选今天之后的日期 新号限制只能选2个月内的 携号限制4个月内 并且周末不允许办理
          return rules({
            time: time,
            type: this.registerTypeId == 2 ? 't+3' : 't+2'
          }) || new Date().getTime() + ((this.registerTypeId == 2 ? 120 : 60) * 24 * 60 * 60 * 1000) < time.getTime() || time.getTime() < Date.now() || ban(time)
        }
      }
    }
  },
  created () {
    this.$nextTick(() => {
      //el-select 在移动端点击不能输入的的bug
      Array.from(document.getElementsByClassName('el-select')).forEach((item) => {
        item.children[0].children[0].removeAttribute('readOnly')
        item.children[0].children[0].onblur = function () {
          let _this = this
          setTimeout(() => {
            _this.removeAttribute('readOnly')
          }, 200)
        }
      })
    })
  },
  mounted () {
    this.packageType = this.$route.query.packageType;
    this.broadAccountQuery();
    this.getjiajuTel();
  },
  methods: {
    getjiajuTel () { //获取家居电话信息
      let parms = {
        type: 35,
        value: 398
      };
      this.$http('admin/dectionaryApp', parms).then(res => {
        if (res && res.returnCode == 1000) {
          if (res.pageData.length > 0) {
            this.homePhoneName = res.pageData[0]['name'];
          }
        }
      });
    },
    handleShipEffectDate () {
      this.form.effectDate = null
    },
    inputFunction () {
      let mgmInput = document.getElementById("mgmInput");
      let value = mgmInput.value;
      if (value.length === 8) {
        //查詢mgm是否有效 暫時不需要
        // this.checkMgmValid(mgmValue);
      }
    },
    handlePhoneChange (param) {
      this.$refs['baseInfo'].phoneNo = param
      this.form.broadbandOrderAllInfo.phoneNumber = param
    },
    getEsimClause () {
      this.$http('newQueryByCode', {
        code: 'esim',
        isOpen: 1
      }).then(res => {
        if (res.returnCode == 1000) {
          let { name, content } = res.dataInfo[0]
          this.dialog.content = content
          this.dialog.title = name
        }
      })
    },
    handleSIMChange (params) {
      this.form.transactType = params
      this.handlerShipShow(-1)
      if (params == 5) this.dialogFn({ show: true })
    },
    async handleNowUseCard (params) {
      //现在使用的卡片  2 = 月费计划 1 = 储值卡
      if (params == 1) {
        let CNMobile = this.$refs.way.form.CNMobile
        debugger
        if (CNMobile == 1) {
          //是中国移动储值卡
          this.registerTypeId = 3
        } else {
          //不是中国移动储值卡
          this.registerTypeId = 2
        }
      } else {
        this.registerTypeId = 2
      }
      await this.getData()
      await this.gainVASList()
      await this.getDiscontsData()
    },
    async handleCNMobileChange (params) {
      let registerType = this.form.registerType
      if (params == 1) {
        //是移动号码
        this.registerTypeId = 3
      } else {
        //不是移动号码
        this.registerTypeId = 2
      }
      await this.getData()
      await this.gainVASList()
      await this.getDiscontsData()
    },
    beforeClose (done) {
      this.$refs.way.sim = '2'
      done()
    },
    dialogFn ({ show, cancle }) {
      if (cancle) {
        this.$refs.way.sim = '2'
      }
      this.handlerShipShow(-1)
      this.dialog.show = show
    },
    detailsFn (params) {
      this.details = params
    },
    handlerShipShow (transactType) {
      let sim = this.$refs.way.sim
      if (sim == 2) {
        //選擇的實體SIM卡
        this.$refs.baseInfo.showShip = true
        if (transactType) {
          this.form.transactType = transactType
          if (transactType == '4') {
            //後台會返回4||6 都是顯示智能自取櫃
            transactType = '6'
          }
          this.$refs.baseInfo.transactType = transactType
        }
      } else {
        //選擇的eSIM卡
        this.$refs.baseInfo.showShip = false
        this.form.transactType = sim
      }
    },
    async handleRegisterType (params) {
      //獲取物流方式
      this.form.registerType = params
      let res = await this.gainShipMethod()
      if (res) {
        this.$refs.baseInfo.setRegisterType(params)
      }
      //获取优惠信息,切换上台方式的时候重新请求优惠信息数据
      if (params == 1) {
        //新号上台
        this.registerTypeId = 1
      } else {
        let simType = this.$refs.way.form.simType
        if (simType == 2) {
          //月费计划
          this.registerTypeId = 2
        } else {
          // simType == 1
          //储值卡
          this.registerTypeId = 3
        }
      }
      await this.getData()
      await this.gainVASList()
      await this.getDiscontsData()
    },
    submit () {
      let { registerOrderId, broadbandOrderId, registerId, broadId, packageType, scene } = this.$route.query
      let params;
      let form = Object.assign({}, this.form);
      form.businessType = packageType; // 业务场景 1.带机上台，13.学生上台
      form.billType = form.broadbandOrderAllInfo.billType; // 賬單方式
      form.billLang = form.broadbandOrderAllInfo.contractLanguage; // 賬單語言
      // 上台生效日期
      form.effectDate = new Date(form.effectDate).getTime() // 字符串數字轉換時間戳
      if (form.customerInfo && form.customerInfo.referrerMsisdn && form.customerInfo.referrerMsisdn.length) {
        form.mgmCode = this.gerencode
        form.mgmMethod = this.mgmMethod
      }
      let customerInfo = Object.assign({}, form.customerInfo);
      delete customerInfo.addressInfoVo
      delete customerInfo.referrerMsisdn
      let broadbandOrderAllInfo = Object.assign({
        id: broadbandOrderId,
        businessCode: this.broadbandOrderAllInfo.businessCode,
        businessId: this.broadbandOrderAllInfo.businessId,
        contractPeriod: this.broadbandOrderAllInfo.contractPeriod,
        cnLastName: '',
        customerType: 2, // 客戶類型 1.存量客户，2.新客
        paymentMethod: '2', // 繳費方式 1:信用卡自动转账,2:其他方式
        paymentAccount: '',
        certificateImgPath: form.certificateAttach,
        certificateType: 1, //證件類型,1身份證，2護照
        ...customerInfo
      }, form.broadbandOrderAllInfo);
      delete form.broadbandOrderAllInfo
      delete form.customerInfo_referrerMsisdn
      let registerOrderAllInfo = Object.assign({
        id: registerOrderId,
        businessPlanCode: this.registerOrderAllInfo.businessPlanCode,
        businessPlanId: this.registerOrderAllInfo.businessPlanId,
        contractPeriod: this.registerOrderAllInfo.contractPeriod,
        orgId: this.$client.orgid,
        shopId: this.$client.shopid,
        userId: this.$client.userid,
        orgCode: "UMALL",
        // operator: "P4246"
      }, form);
      //添加MgmCode
      params = {
        broadbandOrderAllInfo,
        registerOrderAllInfo
      }
      this.$http('broadband/saveOrderInfo', params).then(res => {
        if (res.returnCode == 1000) {
          if (this.type == 1) {
            this.$router.replace({
              name: 'UmallBroadbandConfirm',
              query: {
                registerOrderId,
                broadbandOrderId,
                registerId,
                broadId,
                packageType,
                scene
              }
            })
          } else {
            this.$router.push({ name: 'UmallResult', params: { status: 'success' }, query: { type: 'appointment' } })
          }
        } else {
          //判斷records字段
          let records = res.records
          if (records && records.length) {
            this.disRecords = records
            let allMustSelect = true   //是否都是必选
            for (let index = 0; index < records.length; index++) {
              const recordItem = records[index];
              this.currentDiscDataLv1List.forEach(element => {
                if (element.offerId == recordItem.offerId) {
                  element.endDate = recordItem.endDate
                  element.showDateTips = true
                  if (element.required * 1 == 2 || element.required * 1 == 3) {
                    //選中的才在篩選的範疇
                    if (element.checked) {
                      allMustSelect = false
                    }
                  }
                }
              })
              this.currentPackageLv1List.forEach((element, cindex) => {
                element.discountsList.forEach((delement, dindex) => {
                  if (delement.offerId == recordItem.offerId) {
                    element.showDateTips = true
                    delement.endDate = recordItem.endDate
                    if (delement.required * 1 == 2 || delement.required * 1 == 3) {
                      if (element.selectType == 'multiSelectOne') {
                        //選中的才在篩選的範疇
                        if (element.radioBoxSelectIndex == dindex) {
                          allMustSelect = false
                        }
                      } else {
                        //選中的才在篩選的範疇
                        if (element.checked) {
                          allMustSelect = false
                        }
                      }

                    }
                  }
                })
              })
            }
            if (allMustSelect) {
              //全必选时，直接去掉，重新请求
              this.disCancel()
            } else {
              //不是全必选时，弹窗
              this.dialog.showDis = true
            }
          }
        }
      })
    },
    toPosition (dom, offsetValue = 100) {
      let {
        offsetTop
      } = dom
      window.scroll(0, offsetTop - offsetValue)
    },
    async next () {
      // 上台方式
      if (this.type == 1) {
        let _way;
        _way = this.$refs.way.getForm()
        if (typeof _way === 'string') return this.$message({ customClass: this.$device, showClose: true, message: _way, type: 'warning' });
        else this.form = Object.assign(this.form, _way)
      }
      // 校验上台优惠vas
      if (this.$refs.daijiDiscVas.submitForm()) this.form = Object.assign(this.form, this.$refs.daijiDiscVas.getForm())
      else {
        return this.$message({ customClass: this.$device, showClose: true, message: '選擇的優惠增值服務有誤', type: 'warning' });
      }
      console.log(JSON.stringify(this.form), 856);
      let _temp;
      this.$refs['dateForm'].validate(async (valid, object) => {
        if (valid) return _temp = true
        else {
          let target = null;
          for (let i in object) {
            if (this.$refs[i]) {
              target = i
              break;
            }
          }
          this.toPosition(this.$refs[target].$el)
          return _temp = false
        }
      });
      if (!_temp) return this.$message({ customClass: this.$device, showClose: true, message: '填寫的生效日期資料有誤', type: 'warning' });
      if (this.openHomePhone) {  // 開通家居電話
        let _broadbandWay;
        _broadbandWay = this.$refs.broadbandWay.getForm()
        if (typeof _broadbandWay === 'string') return this.$message({ customClass: this.$device, showClose: true, message: _broadbandWay, type: 'warning' });
        else this.form.broadbandOrderAllInfo = Object.assign(this.form.broadbandOrderAllInfo, _broadbandWay)
      } else {  // 未选家居电话
        this.form.broadbandOrderAllInfo.homePhone = ''
        this.form.broadbandOrderAllInfo.homePhoneType = '3'
      }
      // 校验宽频优惠vas
      if (this.$refs.broadbandDiscVas.submitForm()) {
        this.form.broadbandOrderAllInfo = Object.assign(this.form.broadbandOrderAllInfo, this.$refs.broadbandDiscVas.getForm())
      } else {
        return this.$message({ customClass: this.$device, showClose: true, message: '選擇的寬頻優惠增值服務有誤', type: 'warning' });
      }
      // 校验寬頻安裝預資料
      if (this.$refs.broadbandInfo.submitForm()) {
        this.form.broadbandOrderAllInfo = Object.assign(this.form.broadbandOrderAllInfo, this.$refs.broadbandInfo.getForm())
      } else {
        return this.$message({ customClass: this.$device, showClose: true, message: '填寫的寬頻安裝預資料有誤', type: 'warning' });
      }
      // 校验个人资料
      if (this.$refs.baseInfo.submitForm()) this.form = Object.assign(this.form, this.$refs.baseInfo.getForm())
      else {
        return this.$message({ customClass: this.$device, showClose: true, message: '填寫的個人資料有誤', type: 'warning' });
      }
      if (this.isShowMgnInput) { //验证推荐人输入是否合法
        let referrerMsisdn = this.form.customerInfo_referrerMsisdn;
        this.form.customerInfo.referrerMsisdn = referrerMsisdn
        let result = this.$regex('phone', referrerMsisdn)
        if (referrerMsisdn && !result) {
          return this.$message({ customClass: this.$device, showClose: true, message: '填寫的推薦人號碼有誤', type: 'warning' });
        }
      }
      if (this.type == 1) {
        //驗證用戶在選擇自取櫃的時候，有沒有選取自取櫃地址
        let transactType = this.form.transactType
        if (transactType == 2) {
          let autoBoxOrg = this.form.takeOrg
          let autoBoxTakeRegion = this.form.takeRegion
          //選擇實體卡
          let baseInfoTransType = this.$refs.baseInfo.transactType
          if (baseInfoTransType == 6 || baseInfoTransType == 4) {
            //用戶選擇了自取櫃
            let tipsMessage = null
            if (!autoBoxOrg) {
              tipsMessage = '請選擇自取櫃區域'
            } else if (!autoBoxTakeRegion) {
              tipsMessage = '請選擇自取櫃'
            } else if (this.$refs.baseInfo.selectHot) {
              let markCode = this.$refs.baseInfo.markAutoBox.edCode
              if (!markCode) {
                tipsMessage = '您選擇了熱門智能櫃，請選擇一個備選智能櫃，以便您能順利的收到卡片'
                //重置用戶選擇的自選櫃
                this.$refs.baseInfo.autoBoxIndex = -1
                this.$refs.baseInfo.form.takeRegion = ''
                this.form.takeRegion = ''
              }
            }
            if (tipsMessage !== null) {
              this.toPosition(this.$refs.baseInfo.$refs.shipPosition)
              return this.$message({ customClass: this.$device, showClose: true, message: tipsMessage, type: 'warning' });
            }
          } else if (baseInfoTransType == -1) {
            this.toPosition(this.$refs.baseInfo.$refs.shipPosition)
            return this.$message({ customClass: this.$device, showClose: true, message: '請選擇物流方式', type: 'warning' });
          }
          if (baseInfoTransType == 6) {
            this.form.transactType = this.$refs.baseInfo.selectTransactType
          } else {
            this.form.transactType = baseInfoTransType
          }
        }
        if (this.form.transactType == 4 || this.form.transactType == 6) {
          if (this.$refs.baseInfo.selectHot) {
            let edCode = this.form.serviceOrgCode
            let markedCode = this.$refs.baseInfo.markAutoBox.edCode
            let temCode = edCode + ',' + markedCode
            this.form.serviceOrgCode = temCode
            let markBox = this.$refs.baseInfo.markAutoBox
            let deliverAddrInfoVo = {
              area: markBox.city,
              district: markBox.district,
              detailedAddress: markBox.markTakeOrg
            }
            this.form.deliverAddrInfoVo = deliverAddrInfoVo
          }
        } else {
          //當物流方式不是 智能自取櫃時，不上傳字段
          delete this.form['takeOrg']
          delete this.form['takeRegion']
          delete this.form['serviceOrgCode']
        }
      }
      this.form.contactAddressInfoVo = this.form.customerInfo.addressInfoVo
      console.log(JSON.stringify(this.form), 944);
      // 額外與後端繳驗身份證正確性            
      let isHkidValid = await this.$http('isHkidValidBoss', {
        hkid: `${this.form.customerInfo.certificateCode.substr(0, 7)}${this.form.customerInfo.certificateCode.substr(7)}`,
        marketScene: 1,
        hkidType: 1,
        businessType: this.$route.query.packageType
      })
      if (isHkidValid.returnCode != '1000') return this.toPosition(this.$refs.baseInfo.$refs.customerInfo_certificateCode_formItem.$el)
      // 預佔並繳驗新號/協號
      if (this.type == 1 && this.form.registerType != 3) {
        let checkNewPhone,
          checkNewPhoneData = {
            phoneNo: this.form.phoneNo,
            effectDate: new Date(this.form.effectDate).getTime()
          }
        if (this.form.registerType == '2') checkNewPhoneData.effectTime = this.form.effectTime
        checkNewPhone = await this.$http(this.form.registerType == '2' ? 'isMnpInfoValidBoss' : 'msisdnCheck', checkNewPhoneData)
        if (checkNewPhone.returnCode != '1000') return this.toPosition(this.$refs.way.$el)
      }

      // 額外檢測先付轉後附
      if (this.form.registerType == 3) {
        let ippCheck = await this.$http('check/ippCheck', {
          phoneNo: this.form.phoneNo,
          effectDate: new Date(this.form.effectDate).getTime(),
          userId: config.default.userId
        })
        if (ippCheck.returnCode != '1000') return this.toPosition(this.$refs.way.$el)
      }
      // 把名字信息转大写
      this.form.customerInfo.lastName = this.form.customerInfo.lastName.toUpperCase()
      this.form.customerInfo.firstName = this.form.customerInfo.firstName.toUpperCase()
      if (this.form.subCustInfo) {
        this.form.subCustInfo.lastName = this.form.subCustInfo.lastName.toUpperCase()
        this.form.subCustInfo.firstName = this.form.subCustInfo.firstName.toUpperCase()
      }
      console.log(JSON.stringify(this.form), 1005);
      // 提交表单
      this.submit()
    },
    disDialogbeforeClose () {
      this.disConfirm()
    },
    disConfirm () {
      //重選，跳轉到第一個失效的優惠那裡
      //彈出有效優惠彈窗，並把過期的標註出來
      let positionRef = ''
      let zindex = -1
      let records = this.disRecords
      for (let index = 0; index < records.length; index++) {
        const recordItem = records[index];
        this.currentDiscDataLv1List.forEach(element => {
          if (element.offerId == recordItem.offerId) {
            element.endDate = recordItem.endDate
            element.showDateTips = true
            positionRef = 'disFormMoreCheck'
          }
        })
        this.currentPackageLv1List.forEach((element, cindex) => {
          if (element.selectType == 'multiSelectMore') {
            if (!positionRef.length) {
              positionRef = 'disFormMultiMoreCheck'
              zindex = cindex
            }
          } else if (element.selectType == 'multiSelectOne') {
            if (!positionRef.length) {
              positionRef = 'disFormMultiOneCheck'
              zindex = cindex
            }
          }
          element.discountsList.forEach(delement => {
            if (delement.offerId == recordItem.offerId) {
              delement.showDateTips = true
              delement.endDate = recordItem.endDate
            }
          })
        })
      }
      let dom;
      if (zindex != -1) {
        let domRef = this.$refs.daijiDiscVas.$refs[positionRef + zindex]
        if (domRef) {
          dom = domRef[zindex].$el
        }
      } else {
        let domRef = this.$refs.daijiDiscVas.$refs[positionRef]
        if (domRef) {
          dom = domRef.$el
        }
      }
      this.$refs.daijiDiscVas.toPosition(dom)
      this.dialog.showDis = false
    },
    disCancel () {
      //過濾掉失效的優惠，並重新發起請求
      let records = this.disRecords
      let removeIndex = []
      let removeVasIndex = []
      for (let index = 0; index < records.length; index++) {
        const recordItem = records[index];
        let offerId = recordItem.offerId
        let bindingId = recordItem.bindingId
        this.form.discountInfoList.forEach((element, index) => {
          if (offerId == element.offerId) {
            //移除過期的優惠
            removeIndex.push(offerId)
          }
        })
        this.form.freeVasInfoList.forEach((element, index) => {
          if (bindingId == element.id) {
            //移除綁定的過期vasid
            removeVasIndex.push(bindingId)
          }
        })
      }
      //去掉所有的重複過期優惠,因為可能同時存在相同的offerId
      let filterList = this.form.discountInfoList.filter(element => {
        let filterIndex = removeIndex.indexOf(element.offerId)
        if (filterIndex > -1) {
          return false
        }
        return true
      })
      let filterVasList = this.form.freeVasInfoList.filter(element => {
        let filterIndex = removeVasIndex.indexOf(element.id)
        if (filterIndex > -1) {
          return false
        }
        return true
      })
      this.form.discountInfoList = filterList
      this.form.freeVasInfoList = filterVasList
      //重新發起請求
      this.dialog.showDis = false
      this.submit()
    },
    // 获取上台服务计划信息
    getData () {
      let daijiBusiness = {
        businessCode: this.registerOrderAllInfo.businessPlanCode,
        businessId: this.registerOrderAllInfo.businessPlanId,
        contractPeriod: this.registerOrderAllInfo.contractPeriod,
        selected: "discounts" + this.registerOrderAllInfo.contractPeriod,
        dataInfoId: this.$route.query.registerId,
        packageId: this.$route.query.registerId,
      };
      return this.$http('packageInfo/queryPcPackage', {
        ...daijiBusiness,
        businessType: this.$route.query.packageType,
        marketSceneId: 1,
        type: this.type,
        registerTypeId: this.registerTypeId
      }).then(res => {
        if (res.returnCode == '1000') {
          try {
            let { businessList, packageType, id, } = res.dataInfo
            // packageType 转化为对应的业务场景类型 （25为学生 12为待机上台） 1.带机上台，2.集客上台,3.购机上台,4.旗舰机上台,5.缴费,6.储值卡增值,7.现有客户买手机,12.净手机购买,13.学生上台,14.简易上台,16.BR集客,17.極速開台,0.普通商品购买
            let _packageType = ({ '25': '13', '12': '1' })[packageType]
            this.packageType = _packageType
            this.dataInfoId = id
            businessList.some(e => {
              if (e.id == daijiBusiness.businessId) {
                if (e[daijiBusiness.selected]) e.discounts = e[daijiBusiness.selected];
                this.businessScenesType = e.businessScenesType * 1
                console.log('businessScenesType ' + this.businessScenesType);
                e.contractList = e.contractList.filter(item => item.months == daijiBusiness.contractPeriod);
                return this.info = e
              }
            })
          } catch (e) { console.warn('请检查返回的数据') }
        }
      })
    },
    // 获取宽频服务计划信息
    getBroadbandData () {
      let broadbandOrderInfo = {
        businessCode: this.broadbandOrderAllInfo.businessCode,
        businessId: this.broadbandOrderAllInfo.businessId,
        contractPeriod: this.broadbandOrderAllInfo.contractPeriod,
        selected: "discounts" + this.broadbandOrderAllInfo.contractPeriod,
        dataInfoId: this.$route.query.broadId,
        packageId: this.$route.query.broadId,
      };
      return this.$http('packageInfo/queryPcPackage', {
        ...broadbandOrderInfo,
        businessType: this.$route.query.packageType,
        marketSceneId: 1,
        type: this.type,
        registerTypeId: this.registerTypeId
      }).then(res => {
        if (res.returnCode == '1000') {
          try {
            let { businessList } = res.dataInfo;
            businessList.some(e => {
              if (e.id == broadbandOrderInfo.businessId) {
                if (e[broadbandOrderInfo.selected]) e.discounts = e[broadbandOrderInfo.selected];
                e.contractList = e.contractList.filter(item => item.months == broadbandOrderInfo.contractPeriod);
                console.log(e, 1135);
                return this.broadbandInfo = e;
              }
            })
          } catch (e) { console.warn('請檢查返回的數據') }
        }
      })
    },
    broadAccountQuery () { // 獲取APP端存儲地址，服務計劃數據
      this.$http('broadband/broadAccountQuery', {
        registerOrderId: this.$route.query.registerOrderId,
        broadbandOrderId: this.$route.query.broadbandOrderId
      }).then(res => {
        if (!res || res.returnCode != 1000 || !res.dataInfo) return this.$message({ customClass: this.$device, showClose: false, message: '獲取訂單數據失敗', type: 'warning' });
        // umall 1+N存儲地址寬頻服務計劃數據
        this.broadbandOrderAllInfo = res.dataInfo && res.dataInfo.broadbandOrderAllInfo || {};
        // umall 1+N存儲上台服務計劃數據
        this.registerOrderAllInfo = res.dataInfo && res.dataInfo.registerOrderAllInfo || {};
        this.init();
      })
    },
    async init () { // 初始化數據
      await this.getData(); // 上台服务计划数据
      await this.getBroadbandData();  // 宽频服务计划数据
      //獲取物流方式
      let shipList = await this.gainShipMethod();
      // 獲取上台優惠信息
      await this.gainVASList()
      await this.getDiscontsData()
      // 獲取宽频優惠信息
      await this.gainBroadbandVASList()
      await this.getBroadbandDiscontsData()
      // 获取esim服务条款
      await this.getEsimClause()
      await this.gainMgmShowStatus();
      this.$nextTick(_ => {
        shipList.some((e, i) => {
          if (e.value == 88) shipList.splice(i, 1)
        })
        this.$refs['baseInfo'].shipList = shipList
        this.$refs['baseInfo'].businessPlanId = this.registerOrderAllInfo.businessPlanId
      })
    },
    async gainMgmShowStatus () { //获取是否需要显示填写推荐人信息
      return this.$http('dictionary', {
        type: 251
      }).then(res => {
        let showMgm = false;
        let appId = config.default.appId;
        if(!res.dataInfo[appId]) return;
        let list = res.dataInfo[appId][251];
        let isShowMGMList = []
        list.forEach(item => {
          //因为数据过大，会导致id解析精度丢失，变成字符串 https://blog.csdn.net/palet/article/details/86755453
          isShowMGMList.push(JSON.parse(item.name))
        });
        let isshowobg = {};
        let packageType = this.packageType
        let businessType = packageType
        let showMgmList = isShowMGMList[0]
        for (var i = 0; i < showMgmList.length; i++) {
          let showMgmListId = showMgmList[i].id
          if (showMgmListId == businessType) {
            isshowobg = showMgmList[i];
          }
        };
        if (isshowobg) {
          //匹配到业务
          if (isshowobg.replan) {
            let replan0 = isshowobg.replan[0];
            let replanList = isshowobg.replan;
            let dataInfoId = this.dataInfoId
            if (replan0 == 0) {
              //replan数组，是0全部允许
              //看id是不是在这个数组里面，在就允许展示
              showMgm = true;
            } else {
              replanList.forEach(element => {
                let id = element
                if (id == dataInfoId) {
                  showMgm = true
                }
              });
            }
          }

          // 1.取对象id,看是不是跟现在上台的业务类型是不是一样。就是你提交接口传入的businessType,看是不是跟id一致。一致就展示
          // 2.看replan数组，是0全部允许，非0，看packageInfo查询到的id是不是在这个数组里面，在就允许展示
          // 3.看plan数组，，是0全部允许，非0，看businessInfo查到的服务计划id是不是在这个数组里面，在就允许展示
          if (isshowobg.plan && showMgm) {
            let plan0 = isshowobg.plan[0];
            let planList = isshowobg.plan;
            let selectBusId = this.info.businessCode
            if (plan0 == 0) {
              //plan数组，，是0全部允许
              //看id是不是在这个数组里面，在就允许展示
              showMgm = true;
            } else {
              planList.forEach(element => {
                let id = element
                if (id == selectBusId) {
                  showMgm = true
                }
              });
            }
          }
        }
        //显示或隐藏MGM输入框
        this.isShowMgnInput = showMgm;
        if (showMgm) {
          this.gainMgmCode();
        }
      })
    },
    async gainMgmCode () {  //获取MgmCode
      return this.$http('dictionary', {
        type: 241
      }).then(res => {
        if (res.dataInfo) {
          let appId = config.default.appId;
          this.gerencode = res.dataInfo[appId][241][0].value;
        }
      });
    },
    //獲取物流方式
    async gainShipMethod () {
      let params = {
        marketId: this.$route.query.scene,
        userId: config.default.userId,
        businessType: this.packageType,
        registerType: this.form.registerType
      };
      return new Promise((resolve, reject) => {
        this.$http('businessInfo/queryShipMethod', params).then(res => {
          if (res && res.returnCode != 1000) {
            this.$message({ customClass: this.$device, showClose: true, message: res.message, type: 'error' });
          }
          const data = res && res.records && res.records.map((item) => {
            return {
              name: item.methodName,
              value: item.type
            }
          })
          console.log(data, '750----')
          if (data.length > 0 && data.length == 1) {
            this.form.transactType = data[0].value;
            //                  	console.log(this.form.transactType,'753')
            this.$refs['baseInfo'].transactType = data[0].value;
          }
          //刷新頁面
          resolve(data);
        });
      });
    },
    //获取上台vas列表
    async gainVASList () {
      let that = this;
      return this.$http('getBusinessVas', {
        id: this.registerOrderAllInfo.businessPlanId,
        registerTypeId: this.registerTypeId,
      }).then(res => {
        let data = res.dataInfo
        let vasDataLv1List = data.vasDataLv1List
        vasDataLv1List.some(element => {
          if (element.months == this.registerOrderAllInfo.contractPeriod) {
            let required = true
            element.dataLv2List.forEach(zelement => {
              if (zelement.required * 1 == 2) {
                required = false
              }
              Vue.set(zelement, 'checked', false)
            })
            element.required = required
            that.currentVasDataLv1 = element
          }
          return (element.months == this.registerOrderAllInfo.contractPeriod)
        })
        this.$refs.daijiDiscVas.form.freeVasInfoList = []
      })
    },
    //獲取上台優惠列表
    async getDiscontsData () {
      let daijiBusiness = {
        businessCode: this.registerOrderAllInfo.businessPlanCode,
        businessId: this.registerOrderAllInfo.businessPlanId,
        contractPeriod: this.registerOrderAllInfo.contractPeriod,
        selected: "discounts" + this.registerOrderAllInfo.contractPeriod,
        dataInfoId: this.$route.query.registerId,
        packageId: this.$route.query.registerId
      };
      return this.$http('getDiscontsData', {
        ...daijiBusiness,
        businessType: this.$route.query.packageType,
        marketSceneId: 1,
        registerTypeId: this.registerTypeId,
        months: this.registerOrderAllInfo.contractPeriod
      }, 'post', {}, false).then(res => {
        let data = res.dataInfo
        let discDataLv1List = data.discDataLv1List  //多选类型
        let discPackageLv1List = data.discPackageLv1List //多选几类型
        discPackageLv1List.forEach(element => {
          let selectableQuantity = element.selectableQuantity * 1
          let discountsListCount = element.discountsList.length
          if (selectableQuantity == discountsListCount) {
            //必选
            element.selectType = 'mustSelect'
            element.mustSelect = true
          } else if (selectableQuantity == 1 && discountsListCount > 1) {
            //多选一
            element.selectType = 'multiSelectOne'
            element.mustSelect = true
            element.radioBoxSelectIndex = null
            element.discountsList.forEach(zelement => {
              if (zelement.required * 1 == 2) {
                element.mustSelect = false
              }
              zelement.checked = false
              zelement.showDateTips = false
            })
          } else if (selectableQuantity > 1) {
            //多选多
            element.selectType = 'multiSelectMore'
            element.mustSelect = true
            element.discountsList.forEach(zelement => {
              if (zelement.required * 1 == 2) {
                element.mustSelect = false
              }
              zelement.checked = false
              zelement.showDateTips = false
            })
          } else {
            element.selectType = 'noneData'
            element.mustSelect = true
          }
        })
        this.$nextTick(() => {
          discDataLv1List.forEach(element => {
            element.checked = false
            element.showDateTips = false
          })
          this.currentDiscDataLv1List = discDataLv1List
          this.currentPackageLv1List = discPackageLv1List
        })
        this.$refs.daijiDiscVas.form.discountInfoList = []
      })
    },
    //获取宽频vas列表
    async gainBroadbandVASList () {
      let that = this;
      return this.$http('getBusinessVas', {
        id: this.broadbandOrderAllInfo.businessId,
        registerTypeId: this.registerTypeId,
      }).then(res => {
        let data = res.dataInfo
        let vasDataLv1List = data.vasDataLv1List
        vasDataLv1List.some(element => {
          if (element.months == this.broadbandOrderAllInfo.contractPeriod) {
            let required = true
            element.dataLv2List.forEach(zelement => {
              if (zelement.required * 1 == 2) {
                required = false
              }
              Vue.set(zelement, 'checked', false)
            })
            element.required = required
            that.broadbandVasDataLv1 = element
          }
          return (element.months == this.broadbandOrderAllInfo.contractPeriod)
        })
        this.$refs.broadbandDiscVas.form.freeVasInfoList = []
      })
    },
    //獲取宽频優惠列表
    async getBroadbandDiscontsData () {
      let broadbandOrderInfo = {
        addressCode: this.broadbandOrderAllInfo.addressCode,
        businessCode: this.broadbandOrderAllInfo.businessCode,
        businessId: this.broadbandOrderAllInfo.businessId,
        // contractPeriod: this.broadbandOrderAllInfo.contractPeriod,
        // selected: "discounts" + this.broadbandOrderAllInfo.contractPeriod,
        // dataInfoId: this.$route.query.broadId,
        // packageId: this.$route.query.broadId,
      };
      return this.$http('getDiscontsData', {
        ...broadbandOrderInfo,
        businessType: "",
        marketSceneId: 1,
        isBroadband: '1',
        registerTypeId: "",
        months: this.broadbandOrderAllInfo.contractPeriod
      }, 'post', {}, false).then(res => {
        let data = res.dataInfo
        this.form.broadbandOrderAllInfo.addressOfferIds = data.addressOfferIds
        let discDataLv1List = data.discDataLv1List  //多选类型
        let discPackageLv1List = data.discPackageLv1List //多选几类型
        discPackageLv1List.forEach(element => {
          let selectableQuantity = element.selectableQuantity * 1
          let discountsListCount = element.discountsList.length
          if (selectableQuantity == discountsListCount) {
            //必选
            element.selectType = 'mustSelect'
            element.mustSelect = true
          } else if (selectableQuantity == 1 && discountsListCount > 1) {
            //多选一
            element.selectType = 'multiSelectOne'
            element.mustSelect = true
            element.radioBoxSelectIndex = null
            element.discountsList.forEach(zelement => {
              if (zelement.required * 1 == 2) {
                element.mustSelect = false
              }
              zelement.checked = false
              zelement.showDateTips = false
            })
          } else if (selectableQuantity > 1) {
            //多选多
            element.selectType = 'multiSelectMore'
            element.mustSelect = true
            element.discountsList.forEach(zelement => {
              if (zelement.required * 1 == 2) {
                element.mustSelect = false
              }
              zelement.checked = false
              zelement.showDateTips = false
            })
          } else {
            element.selectType = 'noneData'
            element.mustSelect = true
          }
        })
        this.$nextTick(() => {
          discDataLv1List.forEach(element => {
            element.checked = false
            element.showDateTips = false
          })
          this.broadbandDiscDataLv1List = discDataLv1List
          this.broadbandPackageLv1List = discPackageLv1List
        })
        this.$refs.broadbandDiscVas.form.discountInfoList = []
      })
    },
    effectDateChange (val) { // 选择生效日期，请求宽频上门安装日期
      this.$refs.broadbandInfo.getInstallDate(val);
    }
  },
  components: {
    stepTitle,
    datePicker,
    step,
    contractPeriod,
    way,
    broadbandWay,
    baseInfo,
    broadbandInfo,
    discountVas,
    next,
    top,
    serviceBtn
  }
}
